import { useTranslation } from "react-i18next";
import "./styles.css";
import { MdKeyboardArrowDown } from "react-icons/md";
import { hexToRgba } from "../../../services/utilitiesService";
import { useState } from "react";

export const Wrinklesv2Description = ({ aiValue }) => {
  const { t } = useTranslation(["customAiInfo"]);

  return (
    <div className="wrinkle-description-container">
      <p className="wrinkle-short-description-text">
        {t(aiValue.toLowerCase().split(" ").join("-") + "-v2-info")}
      </p>
      <div className="wrinkle-category-container">
        {WrinklesCategoryMap.map((wrinkleCategory) => (
          <div key={wrinkleCategory.name}>
            <WrinkleDropDown
              name={wrinkleCategory.name}
              color={wrinkleCategory.color}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const WrinkleDropDown = ({ name, color }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(["customAiInfo"]);

  return (
    <div className="wrinkle-category-dropdown">
      <button
        className="wrinkle-category-dropdown-header"
        onClick={() => setOpen(!open)}
      >
        <div className="wrinkle-category-dropdown-title">
          <span
            className="wrinkle-category-color"
            style={{ background: color, borderColor: hexToRgba(color, 0.5) }}
          />
          <span className="wrinkle-category-name">{t(`${name}-title`)}</span>
        </div>

        <span className={`wrinkle-category-arrow ${open ? "open" : ""}`}>
          <MdKeyboardArrowDown fontSize={16} style={{ color: "black" }} />
        </span>
      </button>

      <div
        className={`wrinkle-category-dropdown-content ${open ? "open" : "closed"}`}
      >
        <p className="wrinkle-category-dropdown-content-text">
          {t(`${name}-description`)}
        </p>
      </div>
    </div>
  );
};

const WrinklesCategoryMap = [
  { name: "crow-feet-wrinkle", color: "#A3D55D" },
  { name: "marionette-line-wrinkle", color: "#68C48B" },
  { name: "forehead-wrinkle", color: "#FDC578" },
  { name: "compression-wrinkle", color: "#C75A56" },
  { name: "frown-line-wrinkle", color: "#5EBDD6" },
  { name: "lip-line-wrinkle", color: "#C05ED6" },
  { name: "mental-crease-wrinkle", color: "#4D28AD" },
  { name: "nasolabial-folds-wrinkle", color: "#A63D77" },
  { name: "under-eye-wrinkle", color: "#21BDA0" },
  { name: "bunny-lines-wrinkle", color: "#BD219B" },
];
